/**
 * @constructor
 * 
 * subscriber callback: 
 * { 
 *     variant : {
 *        id : string|null, 
 *        valid: bool, 
 *        ringsize: null|string, 
 *        material: null|string 
 *     },
 *     disable : {
 *         ringsize : [...], 
 *         material : [...] 
 *     }
 * }
 */
function AddToCart() {
    this.subscribers = [];
    this.variants = [];
    this.variantAspects = {};
    this.variant = {
        'id' : null,
        'valid' : false
    };
    this.disable = {};
}

AddToCart.prototype.subscribe = function(callback) {
    this.subscribers.push(callback);
};

AddToCart.prototype.triggerChange = function() {
    for(var i=0,l=this.subscribers.length;i<l;i++) {
        this.subscribers[i](this.variant, this.disable);
    }
};

AddToCart.prototype.setVariants = function(variants) {
    
    this.variants = variants;
    this.variantAspects = {};
    
    if(variants.length === 0) {
        return;
    }
    if(variants[0].ringsize) {
        this.variant.ringsize = null;
        this.variantAspects.ringsize = [];
    }
    if(variants[0].material) {
        this.variant.material = null;
        this.variantAspects.material = [];
    }
    for(var i=0,l=this.variants.length;i<l;i++) {
        var v = this.variants[i];
        if(v.ringsize && this.variantAspects.ringsize.indexOf(v.ringsize) === -1) {
            this.variantAspects.ringsize.push(v.ringsize);
        }
        if(v.material && this.variantAspects.material.indexOf(v.material) === -1) {
            this.variantAspects.material.push(v.material);
        }
    }
};

AddToCart.prototype.init = function() {
    
    // make selection if only one choice available
    
    if(this.variants.length === 1) {
        this.setVariant({ id: this.variants[0].id });
    }
    
};

AddToCart.prototype.isValidVariant = function(variant) {
    for(var i=0,l=this.variants.length;i<l;i++) {
        var v = this.variants[i];
        if(this.variantAspects.ringsize && variant.ringsize && variant.ringsize !== v.ringsize) {
            continue;
        }
        if(this.variantAspects.material && variant.material && variant.material !== v.material) {
            continue;
        }
        return true;
    }
    return false;
};

AddToCart.prototype.setVariant = function(variant) {
    
    if(variant === null) { // deselect / reset
        
        this.variant.id = null;
        this.variant.valid = false;
        if(this.variantAspects.ringsize) {
            this.variant.ringsize = null;
        }
        if(this.variantAspects.material) {
            this.variant.material = null;
        }
        this.disable = {};
        this.triggerChange();
        return;
    }
    
    var variantMatch = null;
    
    if(variant.id) { // select by id
        for(var i=0,l=this.variants.length;i<l;i++) {
            var v = this.variants[i];
            if(v.id === variant.id) {
                variantMatch = v;
                break;
            }
        }
    } else {
        
        if(variant.ringsize) {
            if(this.variantAspects.ringsize && this.variantAspects.ringsize.indexOf(variant.ringsize) > -1) {
                this.variant.ringsize = variant.ringsize;
            } else {
                return;
            }        
        }
        if(variant.material) {
            if(this.variantAspects.material && this.variantAspects.material.indexOf(variant.material) > -1) {
                this.variant.material = variant.material;
            } else {
                return;
            }
        }
        
        // check if its a valid match
        
        for(var i=0,l=this.variants.length;i<l;i++) {
            var variantCandidate = this.variants[i];
            if( this.variant.ringsize === variantCandidate.ringsize &&
                this.variant.material === variantCandidate.material    
            ) {
                variantMatch = variantCandidate;
                break;
            }
        }
    }
    
    // variant found or not?
    
    if(variantMatch) {
        
        this.variant.valid = true;
        this.variant.id = variantMatch.id;
        
        if(variantMatch.ringsize) {
            this.variant.ringsize = variantMatch.ringsize;
        }
        if(variantMatch.material) {
            this.variant.material = variantMatch.material;
        }
        
    } else {
        
        this.variant.valid = false;
        this.variant.id = null;
        
        // deselect other aspect
        
        if(variant.ringsize) {
            this.variant.material = null;
        }  else if(variant.material) {
            this.variant.ringsize = null;
        }
    }
    
    // update disable
    
    this.disable = {};
    
    if(this.variant.ringsize && this.variantAspects.material) {
        // all materials are to be disabled
        var disable = this.variantAspects.material.slice();
        for(var i=0,l=this.variants.length;i<l;i++) {
            var v = this.variants[i];
            // except for the ones that are a valid combination with our current ringsize
            if(v.ringsize === this.variant.ringsize) {
                var p = disable.indexOf(v.material);
                if(p > -1) {
                    disable.splice(p, 1);
                }
            }
        }
        this.disable.material = disable;
    }
    if(this.variant.material && this.variantAspects.ringsize) {
        // all ringsizes are to be disabled
        var disable = this.variantAspects.ringsize.slice();
        for(var i=0,l=this.variants.length;i<l;i++) {
            var v = this.variants[i];
            // except for the ones that are a valid combination with our current material
            if(v.material === this.variant.material) {
                var p = disable.indexOf(v.ringsize);
                if(p > -1) {
                    disable.splice(p, 1);
                }
            }
        }
        this.disable.ringsize = disable;
    }
    
    // trigger event
    
    this.triggerChange();
};
